/** Stash a Mission Control task-thread composer draft before navigation. */

const STORAGE_KEY = "ani.task-thread-draft";

export interface TaskThreadDraft {
  taskId: string;
  message: string;
}

export function stashTaskThreadDraft(draft: TaskThreadDraft): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...draft, at: Date.now() }));
  } catch {
    // ignore quota / private mode
  }
}

export function consumeTaskThreadDraft(taskId: string): string | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as TaskThreadDraft & { at?: number };
    if (parsed.taskId !== taskId) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    return parsed.message?.trim() || null;
  } catch {
    return null;
  }
}

export function missionControlTaskPath(taskId: string, interactionId?: string | null): string {
  const params = new URLSearchParams();
  params.set("task", taskId);
  if (interactionId) {
    params.set("focus", `interaction:${interactionId}`);
  }
  return `/mission-control?${params.toString()}`;
}
